// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"92062887","239":"28b5cb74","455":"d2c1dc20"}[chunkId] + ".chunk.js";
};